module.exports = __webpack_public_path__ + "static/media/view-continuous-assessment.9dd705f5.svg";